import { render, staticRenderFns } from "./labAssignementStatus.vue?vue&type=template&id=efeeb736&scoped=true"
import script from "./labAssignementStatus.vue?vue&type=script&lang=js"
export * from "./labAssignementStatus.vue?vue&type=script&lang=js"
import style0 from "./labAssignementStatus.vue?vue&type=style&index=0&id=efeeb736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeeb736",
  null
  
)

export default component.exports